import { RootState } from '../../../store';

export const getAchievementSelector = (state: RootState) =>
  state.achievement.achievement;
export const getImageSelector = (state: RootState) =>
  state.achievement.achievement?.image;

export const getAchievementsLoadingSelector = (state: RootState) =>
  state.achievement.isLoading;
